import ErrorComponent from "@/components/atoms/ErrorComponent";
import Loader from "@/components/atoms/Loader";
import { PaginateCardProps } from "@/interfaces/Card";
import { IFilters } from "@/interfaces/Fetch";
import { useGetCompanyEmailsQuery } from "@/services/companies/emails";
import { FC, useEffect, useState } from "react";
import EmailLogsCard from "../emails/EmailLogsCard";

const CompanyMailsCard: FC<PaginateCardProps & IFilters & { id: string }> = ({
  onGetTotal,
  id,
  ...props
}) => {
  const [filters, setFilters] = useState<IFilters>({
    pageIndex: 0,
    pageSize: 10,
    ...props,
  });

  const { data, isLoading, isError, error } = useGetCompanyEmailsQuery([
    id,
    filters,
  ]);

  useEffect(() => {
    data?.meta && onGetTotal?.(data.meta.total);
  }, [data?.meta]);

  if (isLoading) {
    return <Loader />;
  } else if (isError) {
    return <ErrorComponent error={error} />;
  }

  return (
    <EmailLogsCard
      data={data?.data}
      meta={data?.meta}
      filters={filters}
      setFilters={setFilters}
    />
  );
};

export default CompanyMailsCard;
